<template>
  <a
    class="tooltip-reaction-button"
    href="#"
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
    @click.prevent="$emit('click')"
    ><span
      class="reaction__emoji icon-emoji emoji-large"
      :class="reaction.className"
    ></span
  ></a>
</template>
<script>
export default {
  name: "TooltipReactionButton",
  props: ["reaction"]
};
</script>
